import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer-container">
        <p>&copy; BikeCity! - Online Bike Delivery Site. All Rights Reserved.</p>
            
        </div>
    );
};

export default Footer;